import { render, staticRenderFns } from "./BookData.vue?vue&type=template&id=82e6f73c&scoped=true&"
import script from "./BookData.vue?vue&type=script&lang=js&"
export * from "./BookData.vue?vue&type=script&lang=js&"
import style0 from "./BookData.vue?vue&type=style&index=0&id=82e6f73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e6f73c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VLayout})
